import { BlockAdsRelatedProps } from '../../components/blocks/BlockAdsRelated'
import { AdsCardVariant } from '../../components/AdsCard/styled'
import { Classified } from '../../rest/types/Classified'
import Router from '../../routes/Router'
import routes from '../../routes/definitions'
import { getCharacters } from '../../helpers/StringHelpers'
import { humanDate } from '../../helpers/DateHelpers'

export function adsRelatedTransformer({
  classifiedsByCategoryResponse,
  t,
}: {
  classifiedsByCategoryResponse: Array<Classified>
  t: any
}): BlockAdsRelatedProps | undefined {
  return classifiedsByCategoryResponse
    ? {
        title: t('block_ads_related_title'),
        items: classifiedsByCategoryResponse?.map((item) => ({
          title: item?.title,
          publicationDate: `${t('block_ads_related_publish_label')} ${humanDate(
            item?.publishedAt ?? '',
            true
          )}`,
          localization: t('city_postal_code_formated', {
            city: item?.city,
            postalCode: getCharacters(item?.postalCode ?? '', 0, 2),
          }),
          description: item?.summary,
          offerType: item?.classifiedCategory?.name,
          adViewsNumber: String(item?.classified_views?.length) ?? '0',
          adCommentNumber: String(item?.classified_answers?.length) ?? '0',
          link: {
            href: Router.getRouteUrl(routes.classified, {
              slug: item?.slug,
            }),
            text: t('more_information_button_text'),
          },
          variant: AdsCardVariant.secondary,
        })),
      }
    : undefined
}
